var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "aside",
    { staticClass: "main-sidebar sidebar-light-lightblue elevation-2" },
    [
      _c("router-link", { attrs: { to: "/admin/home", title: "SiTrendi" } }, [
        _c("img", {
          staticClass: "brand-image",
          staticStyle: {
            opacity: "0.8",
            width: "160px",
            margin: "5px 40px -8px 40px",
          },
          attrs: {
            src: _vm.app_logo,
            alt: "SiTrendi - Sistem Pesantren Digital",
          },
        }),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar" }, [
        _c("nav", { staticClass: "mt-2" }, [
          _c(
            "ul",
            {
              staticClass: "nav nav-pills nav-sidebar flex-column",
              attrs: {
                "data-widget": "treeview",
                role: "menu",
                "data-accordion": "false",
              },
            },
            _vm._l(_vm.permissions, function (permission, index) {
              return _c(
                "li",
                {
                  key: index,
                  class:
                    "nav-item " +
                    index +
                    (permission.permissions.length > 0 &&
                    _vm.currentSelection === index
                      ? " menu-is-opening menu-open"
                      : ""),
                  on: {
                    click: function ($event) {
                      return _vm.toogleItem(index)
                    },
                  },
                },
                [
                  _c(
                    "router-link",
                    {
                      class:
                        "nav-link" +
                        (_vm.currentSelection === index ? " active" : ""),
                      attrs: {
                        to:
                          permission.permissions.length > 0
                            ? "#"
                            : permission.slug,
                        title: permission.name,
                      },
                    },
                    [
                      _c("i", { class: "nav-icon " + permission.icon }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n              " +
                            _vm._s(permission.name) +
                            "\n              "
                        ),
                        permission.permissions.length > 0
                          ? _c("i", { staticClass: "right fas fa-angle-left" })
                          : _vm._e(),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  permission.permissions.length > 0
                    ? _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.currentSelection === index,
                              expression: "currentSelection === index",
                            },
                          ],
                          staticClass: "nav nav-treeview",
                        },
                        _vm._l(
                          permission.permissions,
                          function (child, childindex) {
                            return _c(
                              "li",
                              {
                                key: index.toString() + childindex.toString(),
                                class:
                                  "nav-item " +
                                  index.toString() +
                                  childindex.toString(),
                                on: {
                                  click: function ($event) {
                                    _vm.toogleSubItem(
                                      index.toString() + childindex.toString()
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    class:
                                      "nav-link" +
                                      (_vm.currentSelectionSub ===
                                      index.toString() + childindex.toString()
                                        ? " active"
                                        : ""),
                                    attrs: {
                                      id: child.permission_id,
                                      to: child.slug,
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "far fa-circle nav-icon",
                                    }),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(child.name) +
                                          "\n                "
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }